import startMeasurer from "mondrian-vanilla/core/util/measure"

export default function useMeasure() {
  if (typeof window !== 'undefined') {
    window.addEventListener('load', startMeasurer);
  }
}